import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { IHolidayState } from './holiday.state';
import { HolidayApi } from '../../models/holiday/holiday-api.model';

export const withHolidayStateMethods = signalStoreFeature(
  { state: type<IHolidayState>() },
  withMethods((store) => ({
    setHolidays: (holidays: HolidayApi[]) => {
      patchState(store, { holidays, loading: false, error: null });
    },
    addHoliday: (holiday: HolidayApi) => {
      patchState(store, { holidays: [holiday, ...store.holidays()], loading: false, error: null });
    },
    updateHoliday: (holiday: HolidayApi) => {
      patchState(store, {
        holidays: store.holidays().map((h) => (h.holidayGuid === holiday.holidayGuid ? holiday : h)),
        loading: false,
        error: null,
      });
    },
    removeHoliday: (holidayGuid: string) => {
      patchState(store, {
        holidays: store.holidays().filter((h) => h.holidayGuid !== holidayGuid),
        loading: false,
        error: null,
      });
    },
    setError: (error: string) => {
      patchState(store, { error, loading: false });
    },
  }))
);
